import {
  buildHeaderText,
  TabDefinition,
} from '@features/executive-report/slides/header-texts';

const tabDefinitions = [
  { label: 'Overview', id: 'overview', options: { x: 2.92, w: 1.26 } },
  { label: 'The Who', id: 'who', options: { x: 4.26, w: 1.14 } },
  { label: 'The What', id: 'what', options: { x: 5.56, w: 1.24 } },
  { label: 'The Where', id: 'where', options: { x: 6.92, w: 1.38 } },
  { label: 'The How', id: 'how', options: { x: 8.42, w: 1.18 } },
  { label: 'Summary', id: 'summary', options: { x: 9.68, w: 1.18 } },
  {
    label: 'Recommendations',
    id: 'recommendations',
    options: { x: 10.98, w: 2.22 },
  },
] as const satisfies readonly TabDefinition[];

export type TabId = (typeof tabDefinitions)[number]['id'];

export const headerTabs = (activeTab: TabId) =>
  tabDefinitions.map(tab =>
    buildHeaderText(
      tab.label,
      tab.id === activeTab,
      'options' in tab ? tab.options : undefined
    )
  );
